"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require("react-router");

var _SharerLink = require("@quixeltools/quixel-ui-library/dist/components/common/blog/SharerLink");

var _SharerLink2 = _interopRequireDefault(_SharerLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {};

function FacebookIcon() {
  return _react2.default.createElement(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    _react2.default.createElement("path", {
      d: "M27.3957 3.19995H4.61263C3.83239 3.19995 3.2002 3.83195 3.2002 4.61195V27.388C3.2002 28.1679 3.83239 28.7999 4.61263 28.7999H16.8764V18.888H13.5394V15.024H16.8764V12.176C16.8764 8.86795 18.8971 7.06795 21.846 7.06795C23.2584 7.06795 24.4748 7.17195 24.8269 7.21995V10.676H22.7823C21.1778 10.676 20.8657 11.4399 20.8657 12.556V15.024H24.6908L24.1907 18.888H20.8617V28.7999H27.3877C28.1679 28.7999 28.8001 28.1679 28.8001 27.388V4.61195C28.8081 3.83195 28.1759 3.19995 27.3957 3.19995Z",
      fill: "white"
    })
  );
}

function TwitterIcon() {
  return _react2.default.createElement(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    _react2.default.createElement("path", {
      d: "M10.2837 28.5041C21.6637 28.5041 27.8877 19.0761 27.8877 10.9001C27.8877 10.6321 27.8877 10.3641 27.8677 10.1001C29.0797 9.22411 30.1237 8.14011 30.9557 6.89611C29.8277 7.39611 28.6277 7.72411 27.4037 7.86811C28.6957 7.09611 29.6637 5.88011 30.1237 4.44411C28.9077 5.16411 27.5797 5.67211 26.1957 5.94411C23.8517 3.46011 19.9317 3.34011 17.4397 5.68011C15.8317 7.19211 15.1517 9.44411 15.6517 11.5921C10.6757 11.3441 6.03971 8.99611 2.89971 5.12811C1.25571 7.95611 2.09571 11.5721 4.81571 13.3881C3.83171 13.3601 2.86771 13.0921 2.00771 12.6121C2.00771 12.6361 2.00771 12.6641 2.00771 12.6921C2.00771 15.6361 4.08371 18.1761 6.97171 18.7561C6.05971 19.0041 5.10371 19.0401 4.17971 18.8641C4.99171 21.3841 7.31171 23.1121 9.95971 23.1601C7.76771 24.8801 5.06371 25.8161 2.27571 25.8121C1.78371 25.8121 1.29171 25.7801 0.803711 25.7241C3.63171 27.5401 6.92371 28.5041 10.2877 28.5001",
      fill: "white"
    })
  );
}

function LinkedInIcon() {
  return _react2.default.createElement(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    _react2.default.createElement("path", {
      d: "M26.9042 3.19995H5.0882C4.0482 3.19995 3.2002 4.02795 3.2002 5.04395V26.952C3.2002 27.972 4.0482 28.7999 5.0882 28.7999H26.9042C27.9482 28.7999 28.8002 27.972 28.8002 26.952V5.04395C28.8002 4.02795 27.9482 3.19995 26.9042 3.19995ZM10.7962 25.0119H6.9962V12.796H10.7962V25.0119ZM8.89619 11.128C7.6762 11.128 6.69219 10.14 6.69219 8.92395C6.69219 7.71195 7.6762 6.72395 8.89619 6.72395C10.1122 6.72395 11.0962 7.71195 11.0962 8.92395C11.0962 10.14 10.1082 11.128 8.89619 11.128ZM25.0122 25.0119H21.2202V19.0719C21.2202 17.656 21.1922 15.832 19.2482 15.832C17.2722 15.832 16.9722 17.3759 16.9722 18.9679V25.0119H13.1802V12.796H16.8202V14.464H16.8722C17.3802 13.504 18.6162 12.492 20.4642 12.492C24.3042 12.492 25.0162 15.0199 25.0162 18.3119V25.0119H25.0122Z",
      fill: "white"
    })
  );
}

function ShareLink(props) {
  var type = props.type;


  var sharerProps = {
    facebook: type === "facebook",
    twitter: type === "twitter",
    linkedIn: type === "linkedIn"
  };

  var ShareIcon = null;
  if (type === "facebook") {
    ShareIcon = FacebookIcon;
  } else if (type === "twitter") {
    ShareIcon = TwitterIcon;
  } else if (type === "linkedIn") {
    ShareIcon = LinkedInIcon;
  }

  return _react2.default.createElement(
    _SharerLink2.default,
    sharerProps,
    function (link) {
      return _react2.default.createElement(
        _reactRouter.Link,
        {
          href: link,
          target: "_blank",
          rel: "noreferrer",
          className: styles.starIcon
        },
        ShareIcon ? _react2.default.createElement(ShareIcon, null) : null
      );
    }
  );
}

exports.default = ShareLink;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Blog/Articles.ShareLink.jsx
// module id = 2887
// module chunks = 0